import { render, staticRenderFns } from "./explain-export-aside.component.vue?vue&type=template&id=50fd096c&scoped=true"
import script from "./explain-export-aside.component.vue?vue&type=script&lang=ts"
export * from "./explain-export-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-export-aside.component.vue?vue&type=style&index=0&id=50fd096c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd096c",
  null
  
)

export default component.exports